<template>
  <div class="popup__layer active">
    <div class="popup__edit big">
      <div class="gl-popup__title">
        {{ $t(`account.edit.logo`) }}
      </div>
      <div class="gl-popup__close" @click="close">
        <span class="glicon-close-large"></span>
      </div>

      <div
        ref="drag"
        class="gl-popup__upload"
        :style="isOver ? 'background-color: rgba(0, 126, 255, 0.2);' : null"
        @dragover.prevent
        @drop.prevent
        @drop="onFileDrop"
      >
        <vue-cropper
          v-show="image"
          ref="cropper"
          :src="selectedFile"
          alt="Source Image"
          class="logo"
        ></vue-cropper>
        <span v-show="!image" class="glicon-px-image"></span>
        <span v-show="!image" class="label">{{ $t('account.edit.logoActions.drag') }}</span>
        <span v-show="!image" class="link">
          {{ $t('nouns.or') }}
          <label class="select-img-text" for="account.upload">{{
            $t('account.edit.logoActions.upload')
          }}</label>
          <input
            id="account.upload"
            ref="fileInput"
            class="upload-img"
            type="file"
            name="logo"
            accept="image/*"
            @change="onFileSelect"
          />
        </span>

        <span v-show="!image" class="separator"></span>
        <span v-show="!image" class="label small">{{
          $t('account.edit.logoActions.recommendedOrientation')
        }}</span>
        <span v-show="!image" class="label small">{{
          $t('account.edit.logoActions.dragAndDropMaxImageSize', { sizeInMb: sizeInMb })
        }}</span>
        <span v-show="!image" class="label small">{{
          $t('account.edit.logoActions.validFormat')
        }}</span>
      </div>

      <div class="popup__buttons normal">
        <gl-button
          v-if="!image"
          id="account.btn-update"
          color-secondary
          :type="'button'"
          :text="$t('actions.cancel')"
          @onClick.prevent="close"
        ></gl-button>
        <gl-button
          v-else
          id="account.btn-remove-img"
          color-secondary
          :type="'button'"
          :text="$t('actions.removeImg')"
          @onClick.prevent="removeFile"
        ></gl-button>
        <gl-button
          id="account.btn-update"
          color-primary
          :type="'button'"
          :text="$t('account.forms.save')"
          :disabled="!image"
          @onClick.prevent="uploadImage"
        ></gl-button>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: 'PopUpLogo',
  components: {
    VueCropper
  },
  props: {
    sizeInMb: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mime_type: '',
      cropedImage: '',
      autoCrop: false,
      selectedFile: '',
      image: '',
      isOver: null
    };
  },
  mounted() {
    this.$refs.drag.addEventListener('dragover', () => {
      this.isOver = true;
    });
    this.$refs.drag.addEventListener('dragleave', () => {
      this.isOver = false;
    });
  },
  methods: {
    close() {
      this.$emit('close', false);
    },
    async uploadImage() {
      this.cropedImage = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let updateData = {
        body: {
          logo: this.cropedImage
        },
        notification: {
          type: 'success',
          message: `feedback.success.changeLogo`,
          show: true
        }
      };
      await this.$emit('update-logo', updateData);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      this.close();
    },
    onFileSelect(e) {
      this.image = e.target.files[0];
      this.mime_type = this.image.type;
      if (typeof FileReader === 'function') {
        if (this.isFileValid(this.image)) {
          this.dialog = true;
          const reader = new FileReader();
          reader.onload = (event) => {
            this.selectedFile = event.target.result;
            this.$refs.cropper.replace(this.selectedFile);
          };
          reader.readAsDataURL(this.image);
        } else {
          this.removeFile();
        }
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    onFileDrop(e) {
      let files = e.dataTransfer.files;
      this.image = files[0];
      this.mime_type = this.image.type;

      if (this.isFileValid(this.image)) {
        let reader = new FileReader();
        reader.onload = (f) => {
          this.selectedFile = f.target.result;
          this.$refs.cropper.replace(this.selectedFile);
        };
        this.isOver = false;
        reader.readAsDataURL(this.image);
      } else {
        this.removeFile();
      }
    },
    removeFile() {
      this.$refs.cropper.destroy();
      this.$refs.fileInput.value = '';
      this.image = '';
      this.isOver = false;
    },
    isFileValid(file) {
      if (!['image/jpeg', 'image/png', 'image/gif'].includes(file.type)) {
        return false;
      }
      if (this.sizeInMb && file.size > this.sizeInMb * 1024 * 1024) {
        return false;
      }

      return true;
    }
  }
};
</script>

<style lang="css" scoped>
label {
  cursor: pointer;
  color: #007eff;
  font-size: var(--x-small);
  font-weight: 200;
}
.logo {
  max-width: 300px;
  max-height: 200px;
}

.upload-logo {
  opacity: 0;
  position: absolute;
  z-index: -1;
}
</style>
